import { useQuery } from 'react-query';

import { useSecurePortalFetcher } from '../../../shared/hooks';
import {
  DashboardAccessResponse,
  DashboardTicketResponse,
  DashboardWorkbooksResponse,
} from '../models';

export const useTableauAccessQuery = () => {
  const fetcher = useSecurePortalFetcher();

  return useQuery('tableauAccess', async () => {
    const { data } = await fetcher<DashboardAccessResponse>(
      '/v1/tableau/access'
    ).json();

    return data;
  });
};

export const useDashboardTicketQuery = () => {
  const fetcher = useSecurePortalFetcher();

  return useQuery(['tableau-ticket'], async () => {
    const { data } = await fetcher<DashboardTicketResponse>(
      `/v1/tableau/ticket`
    ).json();

    return data;
  });
};

export const useDashboardWorkbooksQuery = () => {
  const fetcher = useSecurePortalFetcher();

  return useQuery(['tableau-workbooks'], async () => {
    const { data } = await fetcher<DashboardWorkbooksResponse>(
      `/v2/tableau/workbooks`
    ).json();

    return data;
  });
};
